import React from "react";
import { IClientData, IClientFormData, ISession, ITask } from "../../types/dashboard";
import { BottomMenuItems } from "../../mocks/dashboard";

export const DashboardContext = React.createContext<{
    selectedClientId: string;
    setSelectedClientId: React.Dispatch<React.SetStateAction<string>>;
    editClientId: string;
    setEditClientId: React.Dispatch<React.SetStateAction<string>>;
    selectedSessionIndex: number;
    setSelectedSessionIndex: React.Dispatch<React.SetStateAction<number>>,
    selectedTaskIndex: number, 
    setSelectedTaskIndex: React.Dispatch<React.SetStateAction<number>>,
    selectedFolderIndex: number,
    setSelectedFolderIndex: React.Dispatch<React.SetStateAction<number>>,
    selectedBottomMenuTabId: BottomMenuItems, 
    setSelectedBottomMenuTabId: React.Dispatch<React.SetStateAction<BottomMenuItems>>,
    selectedLeftMenuTabIndex: number, 
    setSelectedLeftMenuTabIndex: React.Dispatch<React.SetStateAction<number>>,
    //selectedSessionForEdit: ISession, 
    //setSelectedSessionForEdit: React.Dispatch<React.SetStateAction<ISession>>,
    activeTag: string, 
    setActiveTag: React.Dispatch<React.SetStateAction<string>>,
    isDashWrap: boolean, 
    setDashWrap: React.Dispatch<React.SetStateAction<boolean>>,
    isLeftCollapsed: boolean, 
    setLeftCollapsed: React.Dispatch<React.SetStateAction<boolean>>,
    showMenu: boolean, 
    setShowMenu: React.Dispatch<React.SetStateAction<boolean>>,
    activePopup: string,
    setActivePopup: React.Dispatch<React.SetStateAction<string>>,
    sideSelected: string, 
    setSideSelected: React.Dispatch<React.SetStateAction<string>>,
    bottomSelected: string,
    setBottomSelected: React.Dispatch<React.SetStateAction<string>>,
    isDashboardVisible: boolean,
    setIsDashboardVisible: React.Dispatch<React.SetStateAction<boolean>>,

    selectedClient: IClientData,
    setTaskList: (setter: (last: ITask[])=>ITask[])=>void,

    addClient: (data: IClientFormData) => Promise<void>,
    editClient: (data: IClientFormData)=> void,
    deleteClient: (id: string)=> void,
    editSession: (sessionData: ISession) => void,
    deleteSession: (sessionData: ISession) => void,
    setSelectedSessionForEdit: (session: ISession) => void,
    applySearch: (value: string)=>void;
    filteredClients: IClientData[];
    searchValue: string;

}>({
    selectedClientId: null, 
    setSelectedClientId: null,
    editClientId: null, 
    setEditClientId: null,
    selectedTaskIndex: null, 
    setSelectedTaskIndex: null,
    selectedSessionIndex: null, 
    setSelectedSessionIndex: null,
    selectedFolderIndex: null, 
    setSelectedFolderIndex: null,
    selectedBottomMenuTabId: null, 
    setSelectedBottomMenuTabId: null,
    selectedLeftMenuTabIndex: null, 
    setSelectedLeftMenuTabIndex: null,
    //selectedSessionForEdit: null, 
    //setSelectedSessionForEdit: null,
    sideSelected: null,
    setSideSelected: null,
    bottomSelected: null,
    setBottomSelected: null,
    isDashboardVisible: null,
    setIsDashboardVisible: null,
    activeTag: null, 
    setActiveTag: null,
    isDashWrap: null, 
    setDashWrap: null,
    isLeftCollapsed: null, 
    setLeftCollapsed: null,
    showMenu: null, 
    setShowMenu: null,
    selectedClient: null,
    activePopup: null, 
    setActivePopup: null,
    setTaskList: null,
    addClient: null,
    editClient: null,
    deleteClient: null,
    editSession: null,
    deleteSession: null,
    setSelectedSessionForEdit: null,
    applySearch: null,
    filteredClients: null,
    searchValue: null
});